import React, { useEffect, useState } from 'react';
import Processos from './components/Processos';
import auth from './services/auth';
function App() 
{
  const [user, setUser] = useState("");
  const [cpf, setCpf] = useState("");

  useEffect(()=>{
    setUser(auth.getUser().nome);
    setCpf(auth.getUser().cpf);
  },[])

  return (
    <div>
      <div className="center-text">
          <h1>Bem Vindo {user}</h1>
      </div>
      <Processos />
    </div>
  );
}

export default App;
